"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteInput = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const clsx_1 = __importDefault(require("clsx"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const text_field_1 = require("../text-field/text-field");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const autocomplate_styles_1 = require("./autocomplate-styles");
const autocomplete_context_1 = require("./autocomplete-context");
const autocomplete_loader_hook_1 = require("./hooks/autocomplete-loader-hook");
function AutocompleteInput({ popupOpen, setPopupOpen, textValue, invalidTextValue, setTextValue, setSearchQuery, anchorElRef, inputRef, infiniteListRef, handleSelectItem, handleClear, multiline = false, endAdornment, }) {
    const classes = (0, autocomplate_styles_1.useStyles)();
    const { source, freeSolo, onChange, disabled, onKeyDown, clearable = true, form, autoFocus, } = (0, react_1.useContext)(autocomplete_context_1.AutocompleteContext);
    const { showLoader } = (0, autocomplete_loader_hook_1.useAutocompleteLoader)({
        source,
        freeSolo,
        setPopupOpen,
    });
    const handleChange = (0, event_callback_hook_1.useEventCallback)((value) => {
        setTextValue(value !== null && value !== void 0 ? value : '');
        setSearchQuery(value);
        if (freeSolo) {
            onChange(value);
        }
    });
    const handleClick = (0, event_callback_hook_1.useEventCallback)(() => {
        if (!disabled) {
            (0, react_dom_1.unstable_batchedUpdates)(() => {
                var _a;
                source.reset();
                source.setSearchQuery(textValue !== null && textValue !== void 0 ? textValue : '');
                (_a = infiniteListRef.current) === null || _a === void 0 ? void 0 : _a.reset();
            });
            setPopupOpen(true);
        }
    });
    const handleKeyDown = (0, event_callback_hook_1.useEventCallback)((e) => {
        var _a, _b, _c;
        if (onKeyDown) {
            onKeyDown(e);
        }
        if (e.key !== 'Tab' && e.key !== 'Enter' && !popupOpen) {
            (0, react_dom_1.unstable_batchedUpdates)(() => {
                var _a;
                source.reset();
                source.setSearchQuery(textValue !== null && textValue !== void 0 ? textValue : '');
                (_a = infiniteListRef.current) === null || _a === void 0 ? void 0 : _a.reset();
            });
            setPopupOpen(true);
        }
        if (e.key === 'Tab' && popupOpen) {
            setPopupOpen(false);
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            (_a = infiniteListRef.current) === null || _a === void 0 ? void 0 : _a.focusPrevious();
        }
        else if (e.key === 'ArrowDown') {
            e.preventDefault();
            (_b = infiniteListRef.current) === null || _b === void 0 ? void 0 : _b.focusNext();
        }
        else if (e.key === 'Enter') {
            if (source.count !== 0) {
                e.preventDefault();
                const item = (_c = infiniteListRef.current) === null || _c === void 0 ? void 0 : _c.getFocusedItem();
                if (item !== undefined) {
                    handleSelectItem(item);
                }
            }
        }
        else if (e.key === 'Escape') {
            setPopupOpen(false);
            handleClear();
        }
    });
    return (react_1.default.createElement("div", { className: classes.input, onClick: handleClick, ref: anchorElRef },
        react_1.default.createElement(text_field_1.TextField, { error: invalidTextValue, ref: inputRef, form: form, showClearButton: false, endAdornment: react_1.default.createElement(react_1.default.Fragment, null,
                showLoader && (react_1.default.createElement(CircularProgress_1.default, { size: "18px", className: classes.icon, disableShrink: true })),
                endAdornment && endAdornment,
                clearable && (react_1.default.createElement(IconButton_1.default, { size: "small", onClick: handleClear, className: classes.icon, tabIndex: -1 },
                    react_1.default.createElement(Clear_1.default, { fontSize: "small" }))),
                react_1.default.createElement(IconButton_1.default, { size: "small", classes: {
                        root: (0, clsx_1.default)(classes.icon, {
                            [classes.iconOpened]: popupOpen,
                        }),
                    } },
                    react_1.default.createElement(ArrowDropDown_1.default, { fontSize: "small" }))), autoFocus: autoFocus, value: textValue, onChange: handleChange, onKeyDown: handleKeyDown, multiline: multiline })));
}
exports.AutocompleteInput = AutocompleteInput;
//# sourceMappingURL=autocomplete-input.js.map